import { createContext } from "react"
import type { EventName, EventProperties } from "./types"

export type TrackEventFn = (
  eventName: EventName,
  properties?: EventProperties,
) => void

type TrackEventContextType = {
  trackEvent: TrackEventFn
}

export const TrackEventContext = createContext<TrackEventContextType>({
  trackEvent: (eventName: EventName, properties?: EventProperties) => {
    console.error(eventName, properties)
    return undefined
  },
})
